// extracted by mini-css-extract-plugin
module.exports = {"footer":"FooterContainer_footer__uqvcd","nav":"FooterContainer_nav__2qsba"};